/* SAFA V22 · héro moments */
(function () {
  'use strict';
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function hero(root) {
    if (root.__v22) return; root.__v22 = 1;
    var track = root.querySelector('[data-v22-track]'), slides = $$('[data-v22-slide]', root), dots = $$('[data-v22-go]', root), pause = root.querySelector('[data-v22-pause]');
    var n = slides.length, i = 0, timer = null, stopped = reduce, hover = false;
    var D = (parseInt(root.getAttribute('data-delay'), 10) || 7) * 1000;
    root.style.setProperty('--d', D + 'ms');
    function videos(k, on) {
      $$('video[data-v22-video]', slides[k]).forEach(function (v) {
        if (on && v.offsetParent !== null) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }
    function go(k) {
      var prev = i; i = (k + n) % n;
      track.style.setProperty('--i', i);
      slides.forEach(function (s, j) {
        var on = j === i; s.classList.toggle('is-on', on); s.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('a', s).forEach(function (a) { a.tabIndex = on ? 0 : -1; });
      });
      dots.forEach(function (d, j) { d.classList.remove('is-on'); if (j === i) { void d.offsetWidth; d.classList.add('is-on'); } d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      [i, (i + 1) % n].forEach(function (k) { $$('img[loading="lazy"]', slides[k]).forEach(function (im) { im.loading = 'eager'; }); $$('video[preload="none"]', slides[k]).forEach(function (v) { if (v.offsetParent !== null) v.preload = 'metadata'; }); });
      if (prev !== i) videos(prev, false);
      videos(i, true);
      var t = slides[i].getAttribute('data-theme'); root.setAttribute('data-theme', t || 'light');
    }
    function play() { clear(); if (stopped || hover || n < 2) return; timer = setTimeout(function () { go(i + 1); play(); }, D); }
    function clear() { if (timer) clearTimeout(timer); timer = null; }
    function restart() { go(i); play(); }
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); play(); }); });
    var pv = root.querySelector('[data-v22-prev]'), nx = root.querySelector('[data-v22-next]');
    if (pv) pv.addEventListener('click', function () { go(i - 1); play(); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); play(); });
    if (pause) pause.addEventListener('click', function () {
      stopped = !stopped; root.classList.toggle('is-stopped', stopped); root.classList.toggle('is-paused', stopped);
      pause.setAttribute('aria-label', stopped ? 'Relancer le défilement' : 'Mettre en pause');
      if (stopped) clear(); else restart();
    });
    if (stopped) { root.classList.add('is-stopped', 'is-paused'); }
    var stage = root.querySelector('.v22-hero__stage');
    if (stage && window.matchMedia && matchMedia('(hover: hover)').matches) {
      stage.addEventListener('mouseenter', function () { hover = true; root.classList.add('is-paused'); clear(); });
      stage.addEventListener('mouseleave', function () { hover = false; if (!stopped) { root.classList.remove('is-paused'); restart(); } });
    }
    var x0 = null, y0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { go(i + (dx < 0 ? 1 : -1)); play(); }
      x0 = null;
    });
    root.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { go(i + 1); play(); } if (e.key === 'ArrowLeft') { go(i - 1); play(); } });
    slides.forEach(function (s, j) { s.addEventListener('click', function (e) { if (j !== i && !e.target.closest('a')) { e.preventDefault(); go(j); play(); } }); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) clear(); else play(); });
    addEventListener('resize', function () { videos(i, true); });
    go(0); play();
  }

  function init() { $$('[data-v22-hero]').forEach(hero); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();